import React, { Component } from 'react';
import ChevronDown from 'sushiweb/Icons/all/ChevronDown';
import ChevronUp from 'sushiweb/Icons/all/ChevronUp';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router";

import { getOrderDetails } from '../../../actions/ordersAction';
import { PhotoMainViewer } from './../../core/PhotoViewerComponent';
import { USER_TYPE } from './../../../operations/constants'
import './SummaryPage.scss';

class InvoiceSummary extends Component {

    constructor() {
        super();
        this.state = {
            showDetails: false
        }
    }

    componentDidMount = () => {
        const orderId = this.props.match.params.id;
        this.props.actions.getOrderDetails(orderId);
    }

    showHideDetails = () => {
        const { showDetails } = this.state;
        this.setState({ showDetails: !showDetails });
    }

    filterInvoiceImages = (images) => {
        const invoiceImages = images.reduce( (acc,image) => {
            if(image.entityType === 'invoice' && image.userType === USER_TYPE.DA) {
                acc.push(image);
            }
            return acc;
        }, [] );
        return invoiceImages;
    }
    render() {
        const { images =[] , orderDetail = {} } = this.props.orderDetails || [];
        const { orderId = ""} = orderDetail; 
        const { showDetails } = this.state;
        const invoiceImages = this.filterInvoiceImages(images) || [];
        return (
            <div className="container fs-14 mb-4">
                <div className="pd-bottom-20 pd-top-20 fs-16 w-600">Invoice</div>
                <div>
                    <div>
                        <span className="mr-2">Photos Added</span>
                        <span className="w-600">{invoiceImages.length}</span>
                    </div>
                    {showDetails && <PhotoMainViewer
                        parentClass="order-photo-wrapper"
                        className="order-photo-ele "
                        photos={invoiceImages}
                        id={orderId}
                    />}
                    <div className="green-text flex pd-top-20 w-600" onClick={() => this.showHideDetails()}>
                        {!showDetails ? "View Details" : "Hide Details"}
                        {!showDetails ? <ChevronDown className="ml-1 icon-medium icon-color-green" /> : <ChevronUp className="ml-1 icon-medium icon-color-green" />}
                    </div>
                    <div className="light-line "></div>
                </div>
            </div>
        )
    }
}

const actions = { getOrderDetails }
export default withRouter(connect(
    state => ({
        orderDetails: state.orders.orderDetails || {},
    }),
    dispatch => ({
        actions: bindActionCreators(actions, dispatch),
    }),
)(InvoiceSummary));
